<template>
  <div>
    <steps-order
      :step=4
    ></steps-order>

    <section class="invoice">
      <div class="overlay ModalOverlay" v-if="loading">
        <i class="fa fa-refresh fa-spin"></i>
      </div>
      <!-- title row -->
      <div class="row">
        <div class="col-xs-12">
          <h2 class="page-header">
            <i class="fa fa-globe"></i> Association Belge Francophone de Taekwondo
            <small class="pull-right">Date: {{ getDate() }}</small>
          </h2>
        </div>
      </div>
      <div class="row invoice-info">
        <div class="col-sm-4 invoice-col">
          <p class="lead">Adresse de facturation:</p>
          <address class="text-muted well well-sm no-shadow">
            <strong>{{ getOrder.adresseFacturationForOrder.nom }}
              {{ getOrder.adresseFacturationForOrder.prenom }}</strong><br>
            {{ getOrder.adresseFacturationForOrder.adresse }}<br>
            <span v-if="getOrder.adresseFacturationForOrder.complement!=''">{{ getOrder.adresseFacturationForOrder.complement }}</span>
            {{ getOrder.adresseFacturationForOrder.cp }} {{ getOrder.adresseFacturationForOrder.ville }}<br>
            <span
              v-if="getOrder.adresseFacturationForOrder.mail!=''">{{ getOrder.adresseFacturationForOrder.mail }}</span>
          </address>
        </div>
        <!-- /.col -->

        <!-- /.col -->
        <!--<div class="col-sm-4 invoice-col">-->
        <!--<b>Invoice #007612</b><br>-->
        <!--<br>-->
        <!--<b>Order ID:</b> 4F3S8J<br>-->
        <!--<b>Payment Due:</b> 2/22/2014<br>-->
        <!--<b>Account:</b> 968-34567-->
        <!--</div>-->

        <div class="col-sm-4  invoice-col">
          <p class="lead">Adresse de livraison:</p>
          <address class="text-muted well well-sm no-shadow">
            <strong>{{ getOrder.adresseForOrder.nom }} {{ getOrder.adresseForOrder.prenom }}</strong><br>
            {{ getOrder.adresseForOrder.adresse }}<br>
            <span v-if="getOrder.adresseForOrder.complement!=''">{{ getOrder.adresseForOrder.complement }}</span>
            {{ getOrder.adresseForOrder.cp }} {{ getOrder.adresseForOrder.ville }}<br>
            <span v-if="getOrder.adresseForOrder.mail!=''">{{ getOrder.adresseForOrder.mail }}</span>
          </address>
        </div>

        <div class="col-sm-4  invoice-col">
          <p class="lead">Moyen de payement:</p>
          <div v-if="getModePayement=='payementElectronique' && getSousModePayement=='card'">
            <div class="text-muted well well-sm no-shadow"
                 style="margin-top: 10px;">
              Vous avez choisi le <strong>paiement électronique sécurisé</strong>. <br><br>
              Le total de votre commande sera prélevé sur votre carte **** **** **** {{ getStripePaymentMethod.paymentMethod.card.last4 }}<br>
            </div>
          </div>
          <div v-if="getModePayement=='payementElectronique' && getSousModePayement=='bancontact'">
            <div class="text-muted well well-sm no-shadow"
                 style="margin-top: 10px;">
              Vous avez choisi le <strong>paiement électronique sécurisé</strong>. <br><br>
              Le total de votre commande sera prélevé via Bancontact à l'écran suivant<br>
            </div>
          </div>
          <div v-if="getModePayement=='virement'">
            <div class="text-muted well well-sm no-shadow"
                 style="margin-top: 10px;">
              Vous avez choisi le <strong>paiement par virement bancaire</strong>. <br>
              Confirmez votre commande afin de recevoir les instructions de payement. <br><br>
              <span><em>3 à 5 jours ouvrables peuvent être nécessaires avant le traitement de votre
              commande.</em></span>
            </div>
          </div>
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->

      <!-- Table row -->
      <div class="row">
        <div class="col-xs-12 table-responsive">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Quantité</th>
              <th>Produit</th>
              <th>Description</th>
              <th>Prix unitaire</th>
              <th class="alignright">Total</th>
            </tr>
            </thead>
            <tbody>

            <tr v-if="getCart.licence_renew">
              <td>{{ Object.keys(getCart.licence_renew).length }}</td>
              <td>Renouvellement(s)</td>
              <td>
                <ul>
                  <li v-for="(obj,index) in getCart.licence_renew">
                    • {{ obj.member.fullName }}
                  </li>
                </ul>
              </td>
              <td>40.00 €</td>
              <td class="alignright">{{ getTotalFromCart('licence_renew').toFixed(2).replace(".", ",") }}€</td>
            </tr>
            </tbody>
          </table>
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->

      <div class="row">
        <div class="col-xs-6 col-xs-offset-6">
          <p class="lead">Total de votre commande</p>

          <div class="table-responsive">
            <table class="table table-total">
              <tbody>
              <tr>
                <th style="width:50%">Sous-total:</th>
                <td>{{ getTotalFromCart().toFixed(2).replace(".", ",") }}€</td>
              </tr>
              <tr>
                <th>TVA (0%)</th>
                <td>0,00 €</td>
              </tr>
              <tr>
                <th>Livraison:</th>
                <td>0,00 €</td>
              </tr>
              <tr>
                <th>Total:</th>
                <td>{{ getTotalFromCart().toFixed(2).replace(".", ",") }}€</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->

      <!-- this row will not appear when printing -->
      <div class="row no-print">
        <div class="col-xs-12">
          <!--          <a href="" target="_blank" class="btn btn-default"><i class="fa fa-download"></i> Télécharger cette-->
          <!--            facture</a>-->
          <button @click.prevent="goToPayOrder()" type="button" class="btn btn-warning pull-right">
            <i class="fa fa-credit-card"></i>
            <span v-if="getModePayement=='payementElectronique' && getSousModePayement=='card'">Valider ma commande et mon payement</span>
            <span v-if="getModePayement=='payementElectronique' && getSousModePayement=='bancontact'">Valider ma commande et payer par Bancontact</span>
            <span v-if="getModePayement=='virement'">Valider ma commande</span>

          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <small></small>
        </div>
      </div>

      <div class="row no-print">
        <div class="col-xs-12">
          <small class="pull-right">En validant votre commande, vous acceptez l'intégralité de nos
            <a href="https://www.abft.be/conditions-generales-de-vente-et-dutilisation/" target="_blank">Conditions générales
            de vente</a> ainsi que
            <a href="https://www.abft.be/politique-de-confidentialite/" target="_blank">notre politique de gestion de vos informations personnelles</a>.
          </small>
        </div>
      </div>
    </section>
  </div>
</template>

<script type="text/babel">
import Auth from '@/auth'
import {mapGetters, mapActions} from 'vuex'
import stepsOrder from '../stepsOrder'
import moment from 'moment/moment'
import {prepareCheckoutObject} from "../../utils/utils";
let _ = require('lodash')

export default {
  data() {
    return {
      loading: false,
      stripe: null,
      publishableKey: "pk_test_ytW7NBXCufnUsQOOEsdR28v700tmusZbWL",
      items: [
        {
          sku: 'sku_FdQKocNoVzznpJ',
          quantity: 1
        }
      ],
      successUrl: 'https://www.abft.be/success',
      cancelUrl: 'https://www.abft.be/cancel',
    }
  },
  mounted() {

  },
  methods: {
    ...mapActions({
      setValidatedCart: 'setValidatedCart',
      resetOrder: 'resetOrder',
    }),
    logout: function () {
      Auth.logout();
    },
    goToPayOrder: async function (mode) {
      this.setValidatedCart(true)
      this.loading = true
      let these = this

      if (this.getModePayement == 'virement') {
        this.$router.push({name: 'CongratsOrder'})
      } else if (this.getModePayement == 'payementElectronique' && this.getSousModePayement == 'card') {
        await this.getStripeObject.confirmCardPayment(this.getStripeClientSecretToken,
          {
            payment_method: this.getStripePaymentMethod.paymentMethod.id,
            // receipt_email:this.getOrder.
            return_url: window.location.href.slice(0, window.location.href.lastIndexOf('/')) + "/"
              + "congratsOrder"
          })
          .then((result) => {
            this.loading = false
            if (result.error) {
              this.loading = false
              this.$router.push({name: 'CongratsOrder'})
              // this.$noty.error("Erreur lors du payement de votre commande. ERR106")
            } else {
              this.loading=false
              this.$router.push({name: 'CongratsOrder'})
            }
          });
      } else if (this.getModePayement == 'payementElectronique' && this.getSousModePayement == 'bancontact') {
        await this.getStripeObject.confirmBancontactPayment(this.getStripeClientSecretToken, {
          payment_method: {
            billing_details: {
              name: this.getTitulCardName
            }
          },
          return_url: window.location.href.slice(0, window.location.href.lastIndexOf('/')) + "/"
            + "congratsOrder"
        })
          .then((result) => {
            this.loading = false
            // this.resetOrder()
            if (result.error) {
              this.loading = false
              this.$noty.error("Erreur lors du payement de votre commande. ERR104")
            }
            // if (result.paymentIntent) {
            //   this.loading = false
            //   this.resetOrder()
            //   return true
            // }
          });
      }
    },

    getDate: function () {
      return moment().format('DD/MM/YYYY')
    },
    getTotalFromCart: function (indexSelected = null) {
      let total = 0
      _.map(this.getCart, (item, index) => {
        if (indexSelected && index == indexSelected)
          _.map(item, (obj) => {
            total += obj.price
          })
        else {
          switch (index) {
            case 'licence_renew':
              _.map(item, (obj) => {
                total += obj.price
              })
              break
          }
        }
      })
      return total
    }
  },
  components: {
    stepsOrder,
  },
  computed: {
    ...mapGetters({
      getModePayement: 'getModePayement',
      getSousModePayement: 'getSousModePayement',
      getIdClubSelected: 'getIdClubSelected',
      getClub: 'getClub',
      getCart: 'getCart',
      getTitulCardName: 'getTitulCardName',
      getOrder: 'getOrder',
      getStripeClientSecretToken: 'getStripeClientSecretToken',
      getStripePaymentMethod: 'getStripePaymentMethod',
      getStripeObject: 'getStripeObject'
    })
  },
};
</script>


<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Order/ConfirmOrder.vue